import React from 'react';
import FormItem from 'components/Form2/FormItem';
import { FormMessage, LabelForm } from 'components/Form';
import { TextAreaStyled } from 'components/Form2/styled';
import useMultiLanguageRegisterAccount from 'page/Application/ManageAccountSoliton/RegisterAccountSoliton/hook/useMultiLanguageRegisterAccount';

const FormValidateTextArea = ({
  maxLength,
  disabled,
  name,
  label,
  required,
  placeholder,
  textRequired,
  marginBottom,
  minHeight,
}) => {
  const { REGISTER_ACCOUNT_CATEGORY_ENTRY_REQUIRED } =
    useMultiLanguageRegisterAccount();
  return (
    <FormItem
      marginBottom={marginBottom}
      name={name}
      label={label ? <LabelForm text={'form label validate text'} /> : false}
      rules={[
        {
          required: required,
          message: (
            <FormMessage
              text1={
                textRequired
                  ? textRequired
                  : REGISTER_ACCOUNT_CATEGORY_ENTRY_REQUIRED
              }
              marginBottom={'12px'}
            />
          ),
        },
      ]}
    >
      <TextAreaStyled
        size="large"
        type="text"
        disabled={disabled}
        maxLength={maxLength}
        minHeight={minHeight}
        placeholder={placeholder}
        autoComplete="one-time-code"
      />
    </FormItem>
  );
};

export default FormValidateTextArea;
